import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import LoginHistory from "../../features/manageUsers/loginHistory";
import TransactionHistory from "../../features/manageUsers/transctionHistory";
import ReferralHistory from "../../features/manageUsers/refferalHistory";
import SearchBar from "../../components/SearchBar";
import UserAuditLogTable from "../../features/manageUsers/userAuditLogTable";
import AdjustedPointsTable from "../../features/manageUsers/adjustedPointsTable";
import VerificationModal from "../../Modals/verificationModal";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageUserDetail = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const [valueTabs1, setValueTabs1] = useState(0);
  const [valueTabs2, setValueTabs2] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };

  const [status, setStatus] = useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const tabLabels = [
    "Order Confirmed",
    "Shipped",
    "Out for Delivery",
    "Delivered",
  ];

  const orderData = [
    {
      orderId: "#ORD_001",
      user: {
        name: "John Doe",
        email: "john.doe@example.com",
        phone: "+91 9876543210",
      },
      yoghurtQuantity: "300 ml",
      yoghurtFlavor: "Mango",
      yoghurtToppings: "Mango Chunks, Pistachios, Honey Drizzle",
      totalUnits: 2,
      paymentDetails: "Paid via Credit Card",
      orderDateTime: "29 Oct 2025, 10:30 AM",
      deliveryDateTime: "29 Oct 2025, 11:00 AM",
      status: "Order Confirmed",
    },
    {
      orderId: "#ORD_002",
      user: {
        name: "Alice Smith",
        email: "alice.smith@example.com",
        phone: "+1 222 333 4444",
      },
      yoghurtQuantity: "500 ml",
      yoghurtFlavor: "Strawberry",
      yoghurtToppings: "Strawberry Chunks, Almonds, Chocolate Syrup",
      totalUnits: 1,
      paymentDetails: "Paid via PayPal",
      orderDateTime: "28 Oct 2025, 09:15 AM",
      deliveryDateTime: "28 Oct 2025, 09:45 AM",
      status: "Shipped",
    },
  ];
  const [orderTab, setOrderTab] = useState(0);

  return (
    <>
      <div className="main_title">
        <h1>User Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>Manage Users</button>{" "}
          - User Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              className="custom_tabs_links"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab label="Loyalty Points" {...a11yProps(1)} />
              <Tab label="Order History" {...a11yProps(2)} />
              <Tab label="Feedback & Rating" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Personal Info */}
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="table_header">
            <h2>Personal Info</h2>
            <div className="right_s">
              <Button className="btn btn_primary sm" onClick={() => setOpenModal(true)}>Resend Verification</Button>
            </div>
          </div>
          <div className="gap_p">
            <div className="w_33">
              <h6>Full Name</h6>
              <p>Madelyn Dias</p>
            </div>
            <div className="w_33">
              <h6>Email</h6>
              <p>madelyndias@gmail.com</p>
            </div>
            <div className="w_33">
              <h6>Phone</h6>
              <p>9876543210 <img src="/static/images/tick_icon.svg" alt="verified" /> </p>
            </div>
            <div className="w_33">
              <h6>Nationality</h6>
              <p>Indian</p>
            </div>
            <div className="w_33">
              <h6>Date Registered</h6>
              <p>01 March 2025</p>
            </div>
            <div className="w_33">
              <h6>DOB</h6>
              <p>01 March 2000</p>
            </div>
            <div className="w_33">
              <h6>Member Account</h6>
              <p>MA-40568476</p>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      {/* Loyalty Points */}
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>
                  Total Loyalty Points - <span className="c_primary">1250</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="stats_boxes v2 gap_m">
            <div className="cards">
              <h2>500</h2>
              <p>Total Earned</p>
            </div>
            <div className="cards">
              <h2>100</h2>
              <p>Redeemed</p>
            </div>
            <div className="cards">
              <h2>20</h2>
              <p>Expired</p>
            </div>
            <div className="cards">
              <h2>200</h2>
              <p>In-Process</p>
            </div>
          </div>
        </div>

        <div className="cards mt_20">
          <Box className="custom_tabs">
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              className="custom_tabs_links"
            >
              <Tab label="Transaction history" {...a11yProps(0)} />
              <Tab label="Referral points history" {...a11yProps(1)} />
              {/* <Tab label="Adjusted Points By Admin" {...a11yProps(2)} /> */}
            </Tabs>
          </Box>

          <CustomTabPanel value={valueTabs1} index={0}>
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
                <div className="form">
                  <Select
                    fullWidth
                    value={status}
                    onChange={handleStatusChange}
                  >
                    <MenuItem disabled value="default">
                      Select Type
                    </MenuItem>
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Redeemed">Redeemed</MenuItem>
                    <MenuItem value="Earned">Earned</MenuItem>
                    <MenuItem value="Expired">Expired</MenuItem>
                  </Select>
                </div>
              </div>
            </div>
            <TransactionHistory hideUserColumn />
          </CustomTabPanel>

          <CustomTabPanel value={valueTabs1} index={1}>
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
              </div>
            </div>
            <ReferralHistory />
          </CustomTabPanel>

          {/* <CustomTabPanel value={valueTabs1} index={2}>
            <AdjustedPointsTable />
          </CustomTabPanel> */}
        </div>
      </CustomTabPanel>

      {/* Account Activity */}
      <CustomTabPanel value={valueTabs} index={2}>
        <Box className="custom_tabs1">
          <Tabs
            value={orderTab}
            onChange={(e, newValue) => setOrderTab(newValue)}
            className="custom_tabs_links"
          >
            {tabLabels.map((label, index) => (
              <Tab key={index} label={label} {...a11yProps(index)} />
            ))}
          </Tabs>
        </Box>

        {/* Table */}
        <div className="cards">
          {tabLabels.map((_, tabIndex) => (
            <CustomTabPanel key={tabIndex} value={orderTab} index={tabIndex}>
              <div className="table_header">
                <Box className="search_box">
                  <SearchBar
                    searchTerm={searchTerm}
                    setDebouncedSearchTerm={setSearchTerm}
                    placeholder="Search orders..."
                  />
                </Box>
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Order ID</TableCell>
                      <TableCell>Yoghurt Quantity</TableCell>
                      <TableCell>Yoghurt Flavor</TableCell>
                      <TableCell>Yoghurt Toppings</TableCell>
                      <TableCell>Total Units</TableCell>
                      <TableCell>Payment Details</TableCell>
                      <TableCell>Date & Time of Order</TableCell>
                      <TableCell>Delivery Date & Time</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {orderData
                      .filter((order) =>
                        tabIndex === 0
                          ? order.status === "Order Confirmed"
                          : order.status === tabLabels[tabIndex]
                      )
                      .map((order, index) => (
                        <TableRow hover key={index}>
                          <TableCell>{order.orderId}</TableCell>
                       
                          <TableCell>{order.yoghurtQuantity}</TableCell>
                          <TableCell>{order.yoghurtFlavor}</TableCell>
                          <TableCell>{order.yoghurtToppings}</TableCell>
                          <TableCell>{order.totalUnits}</TableCell>
                          <TableCell>{order.paymentDetails}</TableCell>
                          <TableCell>{order.orderDateTime}</TableCell>
                          <TableCell>{order.deliveryDateTime}</TableCell>
                          <TableCell>
                            <Box display="flex">
                              <IconButton onClick={() => navigate("/manage-order/view")}>
                                <img
                                  src="/static/images/eye_icon.svg"
                                  alt="View"
                                />
                              </IconButton>
                            
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
          ))}
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={3}>
        <div className="cards">
          <PromotionFeedbackTable showUserColumn={false} />
        </div>
      </CustomTabPanel>

      <VerificationModal open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default ManageUserDetail;
